import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services GCP">
                            <h2>Migrate. Transform. Disrupt.</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>With TekRevol's Google Cloud services, you can leverage a powerful duo, manage your IT operations, and reduce downtime and development effort. You can shift your resources and attention to priority tasks such as preparing for future scalability and buildi.With TekRevol's Google Cloud services, you can secure and modernize your data platform and accelerate its utilization. Moreover, you can manage the cost, capacity, and performance of your cloud architecture while availing end-to-end IT Ops with automatic.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;